/* import __COLOCATED_TEMPLATE__ from './discrete-percentage-input.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, set, computed } from '@ember/object';
import { later } from '@ember/runloop';
import { formatBps } from '@capital/intl/utils';
import { DEFAULT_WITHHOLDING_BPS, MAX_WITHHOLDING_BPS, SAVINGS_ACCOUNT_TYPE, BITCOIN_TREASURY_ACCOUNT_TYPE } from '@banking/ui/utils/constants';
const BPS_STEP = 50;
const MAX_PERCENTAGE_DISPLAY = 100_00;
function parseBps(formattedValue) {
  return Number.parseFloat(formattedValue.replace(/%/g, '')) * 100;
}
function round(bps) {
  return Math.round(bps / BPS_STEP) * BPS_STEP;
}
function splice(insertion, start, end, original) {
  const newValue = [...original];
  newValue.splice(start, end - start, insertion);
  return newValue.join('');
}
const ALLOWED_KEYS = new Set(['Tab', 'Enter', 'ArrowDown', 'Down', 'ArrowUp', 'Up', 'ArrowLeft', 'Left', 'ArrowRight', 'Right']);
let DiscretePercentageInput = (_dec = computed('errorMessage.length'), (_class = class DiscretePercentageInput extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _defineProperty(this, "label", void 0);
    _defineProperty(this, "onChange", void 0);
    _defineProperty(this, "bps", DEFAULT_WITHHOLDING_BPS);
    _defineProperty(this, "maxBps", MAX_WITHHOLDING_BPS);
    _defineProperty(this, "minBps", BPS_STEP);
    _defineProperty(this, "inputId", 'banking-discrete-percentage-input-bps');
    _defineProperty(this, "showSlider", false);
    _defineProperty(this, "sliderStep", 100);
    _defineProperty(this, "accountType", SAVINGS_ACCOUNT_TYPE);
    _defineProperty(this, "isBpsValid", true);
    _defineProperty(this, "sliderValue", Math.min(this.bps, this.maxBps));
    // flags if input was typed in (as opposed to input field being directly manipulated)
    _defineProperty(this, "isKeyedIn", false);
    _defineProperty(this, "formattedValue", '0%');
    _defineProperty(this, "errorMessage", void 0);
  }
  get isErrored() {
    return this.errorMessage?.toString().length;
  }
  setCustomValidity() {
    const bps = parseBps(this.formattedValue);
    const input = document.getElementById(this.inputId);
    let message = '';
    if (bps > this.maxBps) {
      if (this.accountType === BITCOIN_TREASURY_ACCOUNT_TYPE) {
        const formattedBps = formatBps(this.maxBps, this.intl);
        message = this.intl.t('banking.investments.percentageInput.errors.maxBps', {
          htmlSafe: true,
          max: formattedBps
        });
      } else {
        message = this.intl.t('banking.components.percentageInput.errors.maxBps', {
          htmlSafe: true,
          max: formatBps(this.maxBps, this.intl)
        });
      }
    } else if (bps > this.automationSubaccountState?.currentMaxBps) {
      message = this.intl.t('banking.components.percentageInput.errors.totalMaxBps', {
        currentMaxBps: formatBps(this.automationSubaccountState.currentMaxBps, this.intl),
        max: formatBps(this.maxBps, this.intl),
        htmlSafe: true
      });
    } else if (bps < this.minBps) {
      const errorString = this.accountType === BITCOIN_TREASURY_ACCOUNT_TYPE ? 'banking.investments.percentageInput.errors.minBps' : 'banking.components.percentageInput.errors.minBps';
      message = this.intl.t(errorString, {
        htmlSafe: true,
        min: formatBps(this.minBps, this.intl)
      });
    } else if (round(bps) !== bps) {
      message = this.intl.t('banking.components.percentageInput.errors.notRoundBps', {
        htmlSafe: true
      });
    }
    set(this, 'errorMessage', message);
    input.setCustomValidity(message.toString());
  }
  _setSliderValue(bps) {
    let newBps = Math.min(bps, this.maxBps);
    newBps = Math.max(newBps, this.minBps);
    set(this, 'sliderValue', newBps);
  }
  _setValue(bps) {
    set(this, 'formattedValue', formatBps(bps, this.intl));
    this.setCustomValidity();
    this.onChange(bps);
    this._setSliderValue(bps);
    set(this, 'isBpsValid', this.isErrored === 0);
  }
  _setValueIfValid(newValue, repositionCursor) {
    const numericalValue = parseBps(newValue);
    const [_whole, decimal] = newValue.split('.');
    if (newValue.replace('%', '') === '' || numericalValue <= MAX_PERCENTAGE_DISPLAY && (!decimal || decimal.length <= 1)) {
      set(this, 'formattedValue', newValue);
      later(repositionCursor, 0);
    }
  }
  onChangeSlider(bps) {
    this._setValue(bps);
  }
  increment() {
    const currentBps = parseBps(this.formattedValue);
    const incrementedBps = round(Math.min(currentBps + BPS_STEP, MAX_PERCENTAGE_DISPLAY));
    this._setValue(incrementedBps);
  }
  decrement() {
    const currentBps = parseBps(this.formattedValue);
    const decrementedBps = round(Math.max(currentBps - BPS_STEP, this.minBps));
    this._setValue(decrementedBps);
  }
  didReceiveAttrs() {
    super.didReceiveAttrs();
    const currentBps = parseBps(this.formattedValue);
    if (this.bps && this.bps !== currentBps) {
      set(this, 'formattedValue', formatBps(this.bps, this.intl));
      this._setSliderValue(this.bps);
    }
  }
  didInsertElement() {
    super.didInsertElement();
    this.setCustomValidity();
  }
  applyBackspace(input) {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    if (start !== null && end !== null) {
      if (start === end && start !== 0) {
        // normal cursor
        const beginning = this.formattedValue.slice(0, start - 1);
        const ending = this.formattedValue.slice(end);
        this._setValueIfValid(`${beginning}${ending}`, () => {
          input.selectionStart = input.selectionEnd = start - 1;
        });
      } else {
        // selection range
        const beginning = this.formattedValue.slice(0, start);
        const ending = this.formattedValue.slice(end);
        this._setValueIfValid(`${beginning}${ending}`, () => {
          input.selectionStart = input.selectionEnd = start;
        });
      }
    } else {
      set(this, 'formattedValue', this.formattedValue.slice(0, -1));
    }
  }
  applyNumber(numberKey, input) {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    let newValue;
    if (this.formattedValue === '0%') {
      newValue = numberKey;
    } else if (start !== null && end !== null && start !== end) {
      newValue = splice(numberKey, start, end, this.formattedValue);
    } else if (this.formattedValue.endsWith('%') && start !== null) {
      if (start <= this.formattedValue.indexOf('%')) {
        newValue = splice(numberKey, start, 0, this.formattedValue);
      }
    } else if (start !== null) {
      newValue = splice(numberKey, start, 0, this.formattedValue);
    }
    if (newValue) {
      this._setValueIfValid(newValue, () => {
        if (start !== null) {
          input.selectionStart = input.selectionEnd = start + 1;
        }
      });
    }
  }
  applyPeriod() {
    if (this.formattedValue.length > 0 && !this.formattedValue.includes('.') && !this.formattedValue.endsWith('%')) {
      set(this, 'formattedValue', `${this.formattedValue}.`);
    }
  }
  applyPercentage() {
    if (!this.formattedValue.endsWith('%')) {
      set(this, 'formattedValue', `${this.formattedValue}%`);
    }
  }

  // called during typical interactions (i.e. user input from keyboard)
  handleKeyDown(event) {
    try {
      if (event.key === 'Backspace') {
        this.applyBackspace(event.target);
      } else if (/\d/.test(event.key)) {
        this.applyNumber(event.key, event.target);
      } else if (event.key === '.') {
        this.applyPeriod();
      } else if (event.key === '%') {
        this.applyPercentage();
      } else if (ALLOWED_KEYS.has(event.key)) {
        // allow tabbing to the submit button, or submitting with Enter, or arrow keys
        return;
      }
      // TODO: do we want to handle copy-paste here?
    } catch {
      // TODO: sentry?
    }

    // throw away event, since we should have applied all valid inputs above
    event.preventDefault();

    // ember-test-helpers has a bug where it doesn't acknowledge preventDefault()
    // so set this flag here so we know how to fix things up in handleChange()
    // https://github.com/emberjs/ember-test-helpers/issues/912
    this.isKeyedIn = true;
    this.setCustomValidity();
    const bps = parseBps(this.formattedValue);
    this.onChange(bps);
    this._setSliderValue(bps);
    set(this, 'isBpsValid', this.isErrored === 0);
  }

  // compensate for bug where ember-test-helpers doesn't respect preventDefault()
  // by syncing the displayed input field value and the internal value
  handleChange(event) {
    const target = event.target;
    if (target.value === this.formattedValue) {
      // already in sync, nothing to fix here
      return;
    }
    if (this.isKeyedIn) {
      // typing happened, so we've been building the value internally with each keystroke
      // internal value is the source of truth
      target.value = this.formattedValue;
      this.setCustomValidity();
    } else {
      // no typing happened, meaning input field was manipulated directly
      // the displayed input field value is the source of truth

      const bps = parseBps(target.value);
      this._setValue(bps);
    }
  }
  handleBlur() {
    let bps = parseBps(this.formattedValue);
    if (Number.isNaN(bps)) {
      bps = 0;
    }
    set(this, 'formattedValue', formatBps(bps, this.intl));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isErrored", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangeSlider", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeSlider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "increment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "increment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "decrement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBlur"), _class.prototype)), _class));
export { DiscretePercentageInput as default };